export default {
    driver_performance_cases_view_createCasesResult: "Crear Casos - Resultado",
    driver_performance_cases_view_dateExecuted: "Fecha de Ejecución",
    driver_performance_cases_view_timeExecutedMinutes: "Tiempo de Ejecución",
    driver_performance_cases_view_casesCreated: "Casos Creados",
    driver_performance_cases_view_casesUpdated: "Casos Actualizados",
    driver_performance_cases_view_casesNoCoachAssigned: "Casos Sin Instructor Asignado",
    driver_performance_cases_view_eventsIgnoredNoDriver: "Eventos Ignorados (Sin Conductor Asignado)",
    driver_performance_cases_view_eventsIgnoredIncompatibleStatus: "Eventos Ignorados (Estado de Evento Incompatible)",
    driver_performance_cases_view_saveSuccessfully: "Casos creados exitosamente",
    driver_performance_cases_view_close: "Cerrar"
};
